import { useState } from "react";
import { Col } from "react-bootstrap";
import Heading from "../heading";
import Button from "../Button";
import Timer from "../timer";
import icons from "../../assets/icons";
import { apiUpdateUserDetails } from "../../helpers/api";
import Tiles from "../tile/tiles";
import "./steps.scss";
import {
  GAMIFIED_STEPS,
  gamifyBoardingActions,
} from "../../redux/slicers/gamifySlicer";
import { CURATOR_ROOM_URL } from "./gamifyOnBoarding";
import { useDispatch } from "react-redux";
import BgImage from "../../assets/images/bgImage.png";
import StepIndicators from "../stepIndicator/stepIndicators";
import { objectToFormData, windowOpen } from "../../helpers/jsHelper";
import { useUserContext } from "../../contexts/UserContext";
import { showHideTooltip } from "../gamificationTooltip/helpers";
import GAMIFIED_FLOW from "../../assets/images/GamifiedFlow.gif";
import { Mixpanel, MxEvent } from "../../common/Mixpanel";

const { Timer: TimerIcon } = icons;
const gamifySteps = [
  { label: "Choose a room" },
  { label: "Add your product" },
  { label: "Style it" },
  { label: "Adjust the camera" },
  { label: "Produce Image" },
];

function StepFive({ name, setStep }) {
  const dispatch = useDispatch();
  const { currentUser, updateUserData } = useUserContext();
  const other_info = currentUser?.user?.other_info;

  const handleClick = async () => {
    dispatch(gamifyBoardingActions.closeGamifiedDialog());
    const data = {
      ...other_info,
      is_gamified_tutorial_completed: true,
    };
    const payload = {
      other_info: JSON.stringify(data),
    };
    const formData = objectToFormData(payload);
    const res = await apiUpdateUserDetails(formData);
    if (res) {
      updateUserData({
        ...currentUser,
        user: {
          ...currentUser?.user,
          other_info: {
            ...other_info,
            ...res?.other_info,
          },
        },
      });
    }
    
    dispatch(gamifyBoardingActions.openShareImageModal());
  };

  return (
    <div
      className="step step-0 d-flex overflow-hidden"
      style={{ borderRadius: "0.5rem" }}
    >
      <Col xs="6" style={{ padding: 40 }}>
        <div className="step-title">
          <Col>
            <Heading type="h2" style={{ fontWeight: 700 }}>
              <Col
                style={{
                  color: "var(--primary-color)",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Great job, {name}!
              </Col>{" "}
              You’ve completed your onboarding tutorial.
            </Heading>
          </Col>
        </div>
        <div className="step-text">
          You can access more tutorials on your homepage.
        </div>
        <div className="step-body">
          <StepIndicators
            steps={gamifySteps}
            currentStep={GAMIFIED_STEPS.SAVE}
          />
        </div>
      </Col>
      <Col
        xs="6"
        className="d-flex align-items-center justify-content-center"
        style={{
          backgroundImage: `url(${BgImage})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundColor: "#1D1D1D",
          padding: 32,
        }}
      >
        <div className="text-center">
          <Button
            color="warning"
            className="text-white"
            size="lg"
            onClick={handleClick}
          >
            Ok, great!
          </Button>
        </div>
      </Col>
    </div>
  );
}

function StepOne({ setStep, rooms }) {
  const dispatch = useDispatch();
  const userCtx = useUserContext();
  const { currentUser, updateUserData } = userCtx;
  const [experience, setExperience] = useState(null);

  const handleSelectExperience = (roomData) => {
    const { room, id, name } = roomData;
    if (room !== experience?.room) {
      setExperience({ room, experienceId: id, name });
    }
  };

  const openRoom = () => {
    if (!experience) return;
    Mixpanel.track( true, 
      MxEvent.GAMIFY_ONBOARDING_STEP_2,
      {
        "Tutorial room id": experience?.experienceId,
        "Room id": experience?.room,
        "Room name": experience?.name,
      }
    );
    setStep?.(GAMIFIED_STEPS.PRODUCT);
    let showTooltip;
    if ("other_info" in currentUser?.user) {
      if ("showTutorialsTooltip" in currentUser?.user?.other_info) {
        showTooltip = false;
      } else {
        showTooltip = true;
      }
    } else {
      showTooltip = true;
    }
    const obj = {
      gamifyOnBoarding: {
        ...currentUser?.other_info?.gamifyOnBoarding,
        data: {
          ...currentUser?.other_info?.gamifyOnBoarding?.data,
          room_id: experience.room,
          tutorial_room_id: experience.experienceId,
        },
        step: GAMIFIED_STEPS.PRODUCT,
      },
      showTutorialsTooltip: showTooltip,
    };
    showHideTooltip(currentUser, updateUserData, obj);
    dispatch(gamifyBoardingActions.closeGamifiedDialog());
    windowOpen(
      `${CURATOR_ROOM_URL.replace(
        ":id",
        experience.experienceId
      )}?isOnboarding=true`,
      "_blank"
    );
  };

  return (
    <div
      className="step step-1 d-flex overflow-hidden"
      style={{ borderRadius: "0.5rem" }}
    >
      <Col xs="6" style={{ padding: 40 }}>
        <div className="step-title">
          <Col>
            <Heading type="h2" style={{ fontWeight: 700 }}>
              <Col
                style={{
                  color: "var(--primary-color)",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Step 1
              </Col>{" "}
              Choose a room template to start with.
            </Heading>
          </Col>
        </div>
        <div className="step-text">
          We’ve created thousands of rooms to inspire you. Choose on that you
          like.
        </div>
        <div className="step-body">
          <StepIndicators
            steps={gamifySteps}
            experience={experience}
            currentStep={GAMIFIED_STEPS.CHOOSE_ROOM}
          />
        </div>
      </Col>
      <Col
        xs="6"
        style={{ background: "#1D1D1D", padding: 32 }}
        className="d-flex flex-column justify-content-between"
      >
        <Tiles
          tiles={rooms}
          selectedId={experience?.experienceId}
          onSelect={handleSelectExperience}
        />
        <div dir="rtl">
          <Button
            color="warning"
            className="text-white"
            size="lg"
            onClick={openRoom}
            style={{ opacity: experience === null ? 0.3 : 1 }}
          >
            Next
          </Button>
        </div>
      </Col>
    </div>
  );
}

function StepZero({ name, setStep }) {
  return (
    <div
      className="step step-0 d-flex overflow-hidden"
      style={{ borderRadius: "0.5rem" }}
    >
      <Col xs="6" style={{ padding: 40 }}>
        <div className="step-title">
          <Col>
            <Heading type="h2" style={{ fontWeight: 700 }}>
              <Col
                style={{
                  color: "var(--primary-color)",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Welcome, {name}.
              </Col>{" "}
              Let’s create your first image together.
            </Heading>
          </Col>
        </div>
        <div className="step-text">
          See how fast and simple it is to create your own image with us in
          these 5 simple steps.
        </div>
        <div className="step-body">
          <StepIndicators
            steps={gamifySteps}
            currentStep={GAMIFIED_STEPS.LETS_START}
          />
        </div>
      </Col>
      <Col xs="6" style={{ background: "#1D1D1D", padding: 32 }}>
        <div
          className="w-100 d-flex justify-content-center align-items-center text-white"
          style={{
            position: "relative",
            height: "340px",
            background: "#696969",
            borderRadius: 5,
            marginBottom: 40,
            overflow: "hidden",
          }}
        >
          <img
            style={{
              position: "absolute",
              width: "100%",
              height: "auto",
              left: 0,
              top: 0,
            }}
            className="d-block img-fluid"
            src={GAMIFIED_FLOW}
            alt="image"
          />
          {/* <span>Gif here</span> */}
        </div>
        <div className="text-center">
          <Timer className="text-white" style={{ marginRight: 28 }}>
            <TimerIcon />
            <span style={{ marginLeft: 8, fontSize: 12 }}>Takes 5 minutes</span>
          </Timer>
          <Button
            color="warning"
            className="text-white"
            size="lg"
            onClick={() => {
              Mixpanel.track( true, 
                MxEvent.GAMIFY_ONBOARDING_STEP_1
              );
              setStep(GAMIFIED_STEPS.CHOOSE_ROOM);
            }}
          >
            Ok, let&lsquo;s do it!
          </Button>
        </div>
      </Col>
    </div>
  );
}

export { StepZero, StepOne, StepFive };
